import {
  FaultItemDisplay,
  FaultItemEdit,
  FaultItemError,
  FaultItemLoading,
} from './FaultItem';
import useFaultAction from '../../data/fault/useFaultAction';

interface FaultActionItemProps {
  index: number;
  actionId: string;
}

interface FaultActionEditProps extends FaultActionItemProps {
  onMoveUp: () => void;
  onMoveDown: () => void;
  onRemove: () => void;
}

export function FaultActionEdit({
  actionId,
  index,
  onMoveUp,
  onMoveDown,
  onRemove,
}: FaultActionEditProps) {
  const { faultAction } = useFaultAction(actionId);

  if (faultAction.isLoading) {
    return <FaultItemLoading />;
  }

  if (!faultAction.data || !faultAction.data.length) {
    return <FaultItemError itemType="Action" id={actionId} />;
  }

  return (
    <FaultItemEdit
      title={faultAction.data?.[0].title}
      description={faultAction.data?.[0].description}
      onMoveUp={onMoveUp}
      onMoveDown={onMoveDown}
      onRemove={onRemove}
      index={index}
    />
  );
}

function FaultActionItem({ actionId, index }: FaultActionItemProps) {
  const { faultAction } = useFaultAction(actionId);

  if (faultAction.isLoading) {
    return <FaultItemLoading />;
  }

  if (!faultAction.data || !faultAction.data.length) {
    return <FaultItemError itemType="Action" id={actionId} />;
  }

  return (
    <FaultItemDisplay
      index={index}
      title={faultAction.data?.[0].title}
      description={faultAction.data?.[0].description}
    />
  );
}

interface FaultActionsProps {
  faultActionIds: string[];
  renderItem?: (props: FaultActionItemProps, index: number) => React.ReactNode;
}

const defaultRenderItem = (props: FaultActionItemProps) => (
  <FaultActionItem {...props} />
);

export function FaultActions({
  faultActionIds,
  renderItem = defaultRenderItem,
}: FaultActionsProps) {
  return faultActionIds.length === 0 ? (
    <p className="text-sm text-gray-500 dark:text-gray-400">
      No actions defined for this fault.
    </p>
  ) : (
    <div className="border border-gray-200 dark:border-gray-700 rounded-lg divide-y divide-gray-200 dark:divide-gray-700">
      {faultActionIds.map((actionId, index) => (
        <div key={actionId}>
          {renderItem({ actionId, index: index + 1 }, index)}
        </div>
      ))}
    </div>
  );
}
